module.exports = __webpack_public_path__ + "img/cooperate_jr_08@2x.254cd642.png";